import { type To } from 'history'

const EXTERNAL_LINK_REGEX = /^(https?:\/\/|mailto:)/

export const isExternalLink = (link: string | To | undefined) =>
  typeof link === 'string' && EXTERNAL_LINK_REGEX.test(link)
